// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__pou0E","rightAdornment":"Header_rightAdornment__24Tg4"};